import { render, staticRenderFns } from "./DlgMemberNew.vue?vue&type=template&id=17baea84&scoped=true&"
import script from "./DlgMemberNew.vue?vue&type=script&lang=ts&"
export * from "./DlgMemberNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17baea84",
  null
  
)

export default component.exports